import {createSlice} from '@reduxjs/toolkit';

import {vendorScoreBuilder} from './reducer';

const initialState: any = {
  loading: 0,
  totalScoreTrend: {},
  requireUrgentAction: {},
  performance: {},
  productScoreTrends: {},
  performanceOverview: {}
};

export const vendorScoreSlicer = createSlice({
  name: 'vendorScore',
  initialState,
  reducers: {},
  extraReducers: vendorScoreBuilder
});

export default vendorScoreSlicer.reducer;
